import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import BaseParagraph from "./baseParagraph";
import { useSelector } from "react-redux";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import enUS from 'date-fns/locale/en-US';
import hr from 'date-fns/locale/hr';
import useColors from "../customHooks/useColors";
registerLocale('en', enUS)
registerLocale('hr', hr)

const BaseDatepicker = ({
  style = {},
  label = null,
  value = null,
  onChange = () => {},
  disabled = false,
  maxDate = new Date(),
  tip = null,
}) => {
  ///////////////////////////////////////////////////////////////// CONSTANTS
  const [currentColors] = useColors();
  const systemState = useSelector(state => state.systemState)
  const lang = systemState.lang;
  
  return (
    <>
      <style>
        {`
          .my-datepicker {
            width: 100%;
            border-color: ${currentColors.primary};
            background-color: ${currentColors.septenary};
            border-width: 0;
            border-bottom-width: 2px;
            font-size: 18px;
            padding-left: 0.275rem;
            padding-bottom: 0.1rem;
          }
          .my-datepicker-popper{

          }
          .react-datepicker {
            background-color:${currentColors.quinary};
          }
          .react-datepicker__triangle::before {
            display:none;
          }
          .react-datepicker__triangle::after {
            display:none;
          }
          .react-datepicker__month-container {
            color:purple !important;
          }

          .react-datepicker__month-container .react-datepicker__day {
            color: ${currentColors.tertiary};
          }

          .react-datepicker__header {
            background-color:${currentColors.primary};
          }

          .react-datepicker__day--selected {
            color: white !important;
          }

         
          .react-datepicker__header div {
            color:${currentColors.secondary};
          }

          .react-datepicker__day--disabled {
            color: gray !important;
          }


          .react-datepicker__day-names {

          }
          .react-datepicker__day-name {
            color: ${currentColors.secondary} }
          .react-datepicker__header__dropdown react-datepicker__header__dropdown--select {

          }
          .react-datepicker__month-select {
            background-color:${currentColors.quinary};
            color: ${currentColors.tertiary};
          }
          .react-datepicker__year-select {
            background-color:${currentColors.quinary};
            color: ${currentColors.tertiary};
          }
          .react-datepicker__day-names {

          }
          .react-datepicker__month {

          }
          .react-datepicker__children-container {
           
          }
        `}
      </style>
      <div>
        <BaseParagraph style={{ ...style }}>{label}</BaseParagraph>
        <DatePicker
          locale={lang}
          selected={value} // obavezno new date ako nije null
          onChange={onChange}
          dateFormat="dd.MM.yyyy"
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          disabled={disabled}
          maxDate={maxDate}
          dropdownMode="select"
          className="my-datepicker"
          popperClassName="my-datepicker-popper"
          //https://reactdatepicker.com/
          //https://www.npmjs.com/package/react-datepicker?activeTab=readme
          //popperPlacement="top-end"
          //isClearable
          //locale={fi}
          //locale="de_DE"
        >
          <BaseParagraph>{tip}</BaseParagraph>
        </DatePicker>
      </div>
    </>
  );
};

export default BaseDatepicker;
